// src/pages/Terms.jsx
import React from 'react';
import './Terms.css';
import Hero from '../components/Home/Hero';

export default function Terms() {
  return (
    <>
      <Hero title="Algemene voorwaarden" />

      <section className="terms-page py-5">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="card shadow-sm p-4">
                <h1 className="mb-4">Algemene voorwaarden</h1>

                <p>
                  Deze algemene voorwaarden zijn van toepassing op alle diensten en overeenkomsten van <strong>OnlineGrowthClub.nl</strong>.
                </p>

                <h2 className="mt-5">1. Diensten</h2>
                <p>
                  Wij leveren digitale diensten zoals webdesign, SEO, SEA en social media marketing. De aard en omvang van de dienstverlening wordt vooraf schriftelijk overeengekomen.
                </p>

                <h2 className="mt-5">2. Offertes en prijzen</h2>
                <p>
                  Offertes zijn vrijblijvend en 14 dagen geldig. Alle prijzen zijn exclusief btw, tenzij anders vermeld.
                </p>

                <h2 className="mt-5">3. Betaling</h2>
                <p>
                  Facturen dienen binnen 14 dagen na factuurdatum te worden voldaan, tenzij anders afgesproken. Bij uitblijvende betaling behouden wij ons het recht voor om werkzaamheden op te schorten.
                </p>

                <h2 className="mt-5">4. Aansprakelijkheid</h2>
                <p>
                  Wij zijn niet aansprakelijk voor indirecte schade of gevolgschade. Onze aansprakelijkheid is beperkt tot het factuurbedrag van de betreffende opdracht.
                </p>

                <h2 className="mt-5">5. Wijzigingen</h2>
                <p>
                  Wij behouden het recht om deze voorwaarden te wijzigen. De meest recente versie is altijd beschikbaar via onze website.
                </p>

                <p className="mt-4 mb-0">
                  Voor vragen kun je contact opnemen via <a href="mailto:info@onlinegrowthclub.nl">info@onlinegrowthclub.nl</a>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
